import { statusColors } from './components/tag'
import { CheckCircleFilledIcon, File04FilledIcon, XCircleIcon } from '../assets/icons'

const statusMapping = {
  published: {
    label: 'Published',
    bg: statusColors.success.bg,
    borderColor: statusColors.success.border,
    color: statusColors.success.color,
    icon: <CheckCircleFilledIcon />,
  },
  draft: {
    label: 'Draft',
    bg: statusColors.warning.bg,
    borderColor: statusColors.warning.border,
    color: statusColors.warning.color,
    icon: <File04FilledIcon />,
  },
  unpublished: {
    label: 'Unpublished',
    bg: statusColors.error.bg,
    borderColor: statusColors.error.border,
    color: statusColors.error.color,
    icon: <XCircleIcon />,
  },
}

export default statusMapping
